import Model  from '@/util/models';

export default class Provinsi extends Model { 
    backend = '/master/settings/';          
}

